import { useState, useRef } from 'react'

import { Center, Spinner, Stack } from '@chakra-ui/react'

import Modal from '../../modal'
import StyledInput from '../../styled/input'
import { useRanContext } from '../../ran-state-provider'

import { userMaintenance } from '../../../lib/api-helper'

import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from '../../../lib/api-config'

const ChangePassword = ({ onClose, setToast }) => {
  const { setAuthentication } = useRanContext()
  const [isLoading, setLoading] = useState(false)
  const [inputVal, setInputVal] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    pin: ''
  })

  const recaptchaRef = useRef(null);

  const handleSubmit = async () => {
    if (isLoading) return
    setLoading(true)

    const captchaToken = await recaptchaRef.current.executeAsync();
    recaptchaRef.current.reset();

    const payload = {
        ...inputVal,
        captchaToken
    };

    const result = await userMaintenance(
      'PASSWORD',
      payload,
      setAuthentication
    )

    const onError = () => {
      setToast({
        status: 'error',
        messages: result?.errors?.length
          ? result.errors
          : ['Something went wrong']
      })
      setLoading(false)
    }

    if (result !== null || result !== undefined) {
      if (result.success) {
        setToast({
          status: 'success',
          messages: ['Password has been successfully updated!']
        })
        onClose()
      } else onError()
    } else onError()
  }

  return (
    <>
    <Modal
      header="CHANGE PASSWORD"
      isOpen={true}
      isLoading={isLoading}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      {isLoading ? (
        <Center>
          <Spinner />
        </Center>
      ) : (
        <Stack spacing={3} w="full">
          <StyledInput
            value={inputVal?.currentPassword}
            onChange={e =>
              setInputVal({ ...inputVal, currentPassword: e.target.value })
            }
            placeholder="CURRENT PASSWORD"
            type="password"
          />
          <StyledInput
            value={inputVal?.pin}
            onChange={e => setInputVal({ ...inputVal, pin: e.target.value })}
            placeholder="PIN CODE"
            type="password"
          />
          <StyledInput
            value={inputVal?.newPassword}
            onChange={e =>
              setInputVal({ ...inputVal, newPassword: e.target.value })
            }
            placeholder="NEW PASSWORD"
            type="password"
          />
          <StyledInput
            value={inputVal?.confirmPassword}
            onChange={e =>
              setInputVal({ ...inputVal, confirmPassword: e.target.value })
            }
            placeholder="CONFIRM NEW PASSWORD"
            type="password"
          />
        </Stack>
      )}
    </Modal>
    <ReCAPTCHA
            sitekey={RECAPTCHA_SITE_KEY}
            size="invisible"
            ref={recaptchaRef}
        />
    </>
  )
}

export default ChangePassword
